$(document).ready(function () {

   $('.btnUpdpass').on('click',function(){
      $(this).hide()
      $('.formpass').show()
   });

   $('.btnUpdEmail').on('click',function(){
      $(this).hide()
      $('.updEmail').show()
   });
   if ( document.querySelector('.formatdate') ) {
      $('.formatdate').mask('00/00/0000');
   }
   
   if ( document.querySelector('.mask-Phone') ) {
      $('.mask-Phone').mask('(00) 00000-0000');
   }

   // var options = {
   //    onKeyPress: function (cpf, ev, el, op) {
   //       var masks = ['000.000.000-000', '00.000.000/0000-00'];
   //       $('.mask-CPF').mask((cpf.length > 14) ? masks[1] : masks[0], op);
   //    }
   // }
   // $('.mask-CPF').length > 11 ? $('.mask-CPF').mask('00.000.000/0000-00', options) : $('.mask-CPF').mask('000.000.000-00#', options);
   // $('.mask-CPF').focusout(function () {

   //    var thisField = $(this);
   //    var validCpfCnpj = validaCpfCnpj(thisField.val());
   //    thisField.parent().find('#inpCPF-error').remove();

   //    if (validCpfCnpj == false) {
   //       var msg;
   //       if (thisField.val().length == 18) {
   //          msg = "CNPJ <strong>" + thisField.val() + "</strong> Inválido";
   //       } else {
   //          msg = "CPF <strong>" + thisField.val() + "</strong> Inválido";
   //       }
   //       thisField.val('');
   //       thisField.addClass('error');
   //       thisField.parent().append('<label id="inpCPF-error" class="error" for="inpCPF">' + msg + '.</label>');
   //    }

   // });


   jQuery.validator.addMethod("cpf", function(value, element) {
      value = jQuery.trim(value);

      value = value.replace('.','');
      value = value.replace('.','');
      cpf = value.replace('-','');
      while(cpf.length < 11) cpf = "0"+ cpf;
      var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
      var a = [];
      var b = new Number;
      var c = 11;
      for (i=0; i<11; i++){
          a[i] = cpf.charAt(i);
          if (i < 9) b += (a[i] * --c);
      }
      if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11-x }
      b = 0;
      c = 11;
      for (y=0; y<10; y++) b += (a[y] * c--);
      if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11-x; }

      var retorno = true;
      if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) retorno = false;

      return this.optional(element) || retorno;

  }, "Informe um CPF válido");

  
   $.validator.addMethod(
      "brazilianDate",
      function (value, element) {
         if (this.optional(element)) return true;
      
         // Verifica se está no formato DD/MM/YYYY
         const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
         const match = value.match(regex);
      
         if (!match) return false;
      
         const day = parseInt(match[1], 10);
         const month = parseInt(match[2], 10) - 1;
         const year = parseInt(match[3], 10);
      
         const date = new Date(year, month, day);
      
         return (
            date.getFullYear() === year &&
            date.getMonth() === month &&
            date.getDate() === day
         );
      },
      "Por favor insira uma data válida no formato DD/MM/YYYY"
   );
 

   jQuery.validator.addMethod("dateBR", function (value, element) {
      //contando chars
      if (value.length != 10) return false;
      // verificando data
      var data = value;
      var dia = data.substr(0, 2);
      var barra1 = data.substr(2, 1);
      var mes = data.substr(3, 2);
      var barra2 = data.substr(5, 1);
      var ano = data.substr(6, 4);
      if (data.length != 10 || barra1 != "/" || barra2 != "/" || isNaN(dia) || isNaN(mes) || isNaN(ano) || dia > 31 || mes > 12) return false;
      if ((mes == 4 || mes == 6 || mes == 9 || mes == 11) && dia == 31) return false;
      if (mes == 2 && (dia > 29 || (dia == 29 && ano % 4 != 0))) return false;
      if (ano < 1900) return false;
      return true;
   }, "Informe uma data válida");

   $.validator.addMethod("passwordFormatCheck", function (value, element) {
      return this.optional(element) || /^(?=.*[a-z])[A-Za-z0-9\d=!\-@._*]+$/i.test(value);
   }, 'A senha deve conter pelo menos uma letra maiúscula, um número e um caracter especial.');

   $(".ssouserlogin").validate({
      rules: {
         email: {
            required: true,
            email: true
         },
         password: {
            required: true,
         },
      },
   });

   $(".ssoremind").validate({
      rules: {
         email: {
            required: true,
            email: true
         }
      },
   });
   

   $(".ssoresetpass").validate({
      rules: {
         password: {
            required: true,
            minlength: 6,
            maxlength: 20,
            // passwordFormatCheck: true,
         },
         confirmar: {
            required: true,
            equalTo: "#password"
         }
      },
      messages: {
         password: {
            minlength: "Por favor, forneça ao menos seis caracteres."
         },
         repassword: {
            equalTo: "Por favor, forneça a mesma senha."
         }
      }
   });

   $(".updpass").validate({
      rules: {
         password: {
            required: true,
            minlength: 6,
            maxlength: 20,
            // passwordFormatCheck: true,
         },
         confirmar: {
            required: true,
            equalTo: "#password"
         }
      },
      messages: {
         password: {
            minlength: "Por favor, forneça ao menos seis caracteres."
         },
         repassword: {
            equalTo: "Por favor, forneça a mesma senha."
         }
      }
   });


   $(".ssoUserSend").validate({
      rules: {
         name: {
            required: true
         },
         email: {
            required: true,
            email: true
         },
         birthdate: {
            dateBR: true,
            required: true
         },
         password: {
            required: true,
            minlength: 6,
            maxlength: 20,
            // passwordFormatCheck: true,
         },
         confirmar: {
            required: true,
            equalTo: "#password"
         }
      },
      messages: {
         cpf: {
            cpf: 'CPF inválido'
         },
         password: {
            minlength: "Por favor, forneça ao menos seis caracteres."
         },
         repassword: {
            equalTo: "Por favor, forneça a mesma senha."
         }
      }
   });

   
   $(".upduser").validate({
      rules: {
         name: {
            required: true
         },
         email: {
            required: true,
            email: true
         },
         birthdate: {
            dateBR: true,
            required: true
         },
         mobilephone: {
            required: true
         },
      },
   });

   
   $(".newsform").validate({
      rules: {
         email: {
            required: true,
            email: true
         }
      },
   });
      
   
   $(".newsformSquare").validate({
      rules: {
         email: {
            required: true,
            email: true
         }
      },
   });
   $(".retNewsOpen").validate({
      rules: {
         email: {
            required: true,
            email: true
         }
      },
   });
      
   $(".ssounsubscribe").validate({
      rules: {
         email: {
            required: true,
            email: true
         }
      },
   });
      
   $(".ssoemailconfirm").validate({
      rules: {
         email: {
            required: true,
            email: true
         }
      },
   });
   
   $(".updEmail").validate({
      rules: {
         newemail: {
            required: true,
            email: true
         },
         password: {
            required: true,
         },
      },
   });

});
